function parseUsingParseInt(stringAsNumber: string | undefined): number {
  if ((stringAsNumber || "").trim()) {
    return parseInt((stringAsNumber || "").trim(), 10);
  }
  return NaN;
}

function stringIsEmpty(value : string | undefined): boolean {
  return value === undefined || value === null || value === "";
}

export { parseUsingParseInt, stringIsEmpty };
